import {InjectionToken} from '@angular/core';
import {CloudPayConfiguration} from './types/cloud-pay-configuration.type';

export const CONFIG_TOKEN = new InjectionToken<CloudPayConfiguration>('CloudPayConfiguration');
